import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {DisposableObject} from "../../../../utils/disposable-object";
import {NullableUndefinedNumber, NullableUndefinedString} from "../../../../common/types/nullable-types";
import {CIPropRead} from "../../../../utils/case-insensitive-property-reader";

export abstract class ExternalLinkHandlerBase extends DisposableObject {
    constructor(protected readonly services: IServiceFactoryExtended) {
        super()
    }

    protected _extractActionId(message: MessageEvent): NullableUndefinedString {
        return CIPropRead.getStringProperty('actionId', message.data);
    }

    protected _extractUrl(message: MessageEvent): NullableUndefinedString {
        return CIPropRead.getStringProperty('url', message.data);
    }

    protected _extractGameId(message: MessageEvent): NullableUndefinedNumber {
        return CIPropRead.getNumericProperty('gameId', message.data);

    }
}